export default __webpack_public_path__ + "static/media/copo.ba4d9179.svg";